import { Icon } from './_Icon';
export const LogoutIcon = (props) => (
  <Icon {...props} d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4 M16 17l5-5-5-5 M21 12H9" />
);
